import { canonicalizeDealerAccountPath } from "@/context/account/dealerAccountRouteId";
import { useAccount } from "@/context/account";
import { format } from "@/utils/format";

export function useNotificationTargetUri(contentUri: string): string {
  const { accounts } = useAccount();
  return canonicalizeDealerAccountPath(
    format.notificationUri(contentUri),
    accounts
  );
}
